"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAndParseDate = exports.getInTranslations = void 0;
const sheet_db_1 = require("../sheet_db");
const date_fns_1 = require("date-fns");
const getInTranslations = () => {
    const inTranslations = {};
    Object.entries(sheet_db_1.OutFormulaTranslations).forEach(([language, translations]) => {
        const organizedTranslations = {
            formulas: {},
            global: { booleans: {} },
        };
        // invert alias, date formats and enum replacements (to convert formula to our frontend)
        Object.entries(translations.formulas).forEach(([key, value]) => {
            const translatedFunction = JSON.parse(JSON.stringify(value));
            organizedTranslations.formulas[translatedFunction.alias] = translatedFunction;
            translatedFunction.alias = key;
            invertDateFormats(translatedFunction);
            invertEnumReplacements(translatedFunction);
        });
        Object.entries(translations.global.booleans).forEach(([key, value]) => (organizedTranslations.global.booleans[value] = key));
        inTranslations[language] = organizedTranslations;
    });
    return inTranslations;
};
exports.getInTranslations = getInTranslations;
const invertDateFormats = (translatedFunction) => {
    const newSourceDateFormat = translatedFunction.target_date_format;
    translatedFunction.target_date_format = translatedFunction.source_date_format;
    translatedFunction.source_date_format = newSourceDateFormat;
};
const invertEnumReplacements = (translatedFunction) => {
    translatedFunction.replacements = translatedFunction.replacements?.map(replace => {
        if (!replace)
            return replace;
        const translatedReplace = {};
        Object.entries(replace).forEach(([k, v]) => {
            translatedReplace[v] = k;
        });
        return translatedReplace;
    });
};
const validateAndParseDate = (inputString, layout) => {
    const formats = [
        'dd-MM-yy',
        'dd/MM/yy',
        'dd-MM-yyyy',
        'dd/MM/yyyy',
        "yyyy-MM-dd'T'HH:mm:ss.SSSX",
        'yyyy-MM-dd HH:mm:ss',
        'yyyy-MM-dd', // Standard date format
    ];
    if (layout) {
        const parsedDate = (0, date_fns_1.parse)(inputString, layout, new Date());
        if ((0, date_fns_1.isValid)(parsedDate)) {
            return {
                isValid: true,
                parsedString: (0, date_fns_1.format)(parsedDate, "yyyy-MM-dd'T'HH:mm:ss.SSSX"),
            };
        }
    }
    for (const fmt of formats) {
        const parsedDate = (0, date_fns_1.parse)(inputString, fmt, new Date());
        if ((0, date_fns_1.isValid)(parsedDate)) {
            return {
                isValid: true,
                parsedString: (0, date_fns_1.format)(parsedDate, "yyyy-MM-dd'T'HH:mm:ss.SSSX"),
            };
        }
    }
    return {
        isValid: false,
        parsedString: inputString,
    };
};
exports.validateAndParseDate = validateAndParseDate;
